import type { UseTextDirectionValue } from "@vueuse/core"

export const useDirection = defineComposable("direction", () => {
	const storedDir = useCookie<UseTextDirectionValue>("direction")
	const dir = computed(() => storedDir.value === "rtl" ? "rtl" : "ltr")

	/**
	 * Since developer is in charge of setting the default direction of the app,
	 * this function must be called in `app.vue` one time.
	 */
	function setDirection(direction: UseTextDirectionValue) {
		storedDir.value = direction

		useHead({
			htmlAttrs: { dir: direction },
		})
	}

	return {
		dir,
		setDirection,
	}
})
